import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from "./store";
import ViewUI from "view-design";
import './common.less'
import { registerMicroApps, start, initGlobalState } from 'qiankun'
import { entries } from './entries'
import config from '@/config'
import getBankcardinfo from 'bankcardinfo'
import { getCurrentType } from "@/libs/util";
import '@/common/lazy_use.js'
import moment from 'moment'

Vue.use(ViewUI);

Vue.config.productionTip = false
window.__POWERED_BY_QIANKUN_PARENT__ = true

const stateActions = initGlobalState({})

const apps = [
  {
    name: 'qhd-cms',
    entry: entries.qhd[process.env.VUE_APP_ENV],
    container: '#sub-container',
    activeRule: '/sub-app/qhd'
  },
  {
    name: 'beauty-cms',
    entry: entries.beauty[process.env.VUE_APP_ENV],
    container: '#sub-container',
    activeRule: '/sub-app/beauty'
  }
]

registerMicroApps(apps)

start({
  sandbox: true,
  prefetch: 'false'
})

Vue.prototype.$stateActions = stateActions
Vue.prototype.$config = config
Vue.prototype.$getBankcardinfo = getBankcardinfo
Vue.prototype.$getCurrentType = getCurrentType
Vue.prototype.$moment = moment

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
